<script lang="ts">
	let props = $props();
</script>

<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
	<path
		d="M5.26308 8.25204C5.61235 7.91599 6.17655 7.91599 6.52581 8.25204L10.0006 11.5953L13.4753 8.25204C13.8246 7.91599 14.3888 7.91599 14.7381 8.25204C15.0873 8.58809 15.0873 9.13094 14.7381 9.46699L10.6275 13.422C10.4438 13.5988 9.9606 14 9.9606 14C9.9606 14 9.53031 13.5814 9.36472 13.422L5.25412 9.46699C4.91381 9.13956 4.91381 8.58809 5.26308 8.25204Z"
		fill="currentColor"
	/>
</svg>
